import * as React from "react";
import { Helmet } from "react-helmet";
import { RouteComponentProps, withRouter, Link } from "react-router-dom";
import { Subscribe } from "unstated";

import { AppContainer } from "../../containers/App.container";
import WaitlistSignUpForm from "../../components/WaitlistSignUpForm/WaitlistSignUpForm";
import styled from "../../styled-components";
import IndexFooter from "./IndexFooter";
import Footer from "../../components/Footer/Footer";
import { media } from "../../breakpoints";
import Nav from "../../components/Nav/Nav";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 100vh;
  overflow-x: hidden;
  position: relative;
`;

const InnerWrapperTop = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  margin: 25px 0 0 0;
  height: calc(66.6vh - 88px);
  @media screen and (max-width: 1302px) {
    height: calc(66.6vh - 124px);
  }
  ${media.TABLET`
    height: auto;
    flex-direction: column;
  `};
`;

const InnerWrapperBottom = styled.div`
  display: flex;
  flex-direction: column-reverse;
  height: 33.3vh;
  width: 100%;
  ${media.TABLET`
    height: auto;
    padding: 25px 0;
  `};
`;

const SubWrapper = styled.div`
  display: flex;
  flex-direction: row;
  width: 50%;
  background-image: linear-gradient(
    to left top,
    #000 0%,
    #000 50%,
    #fff 50%,
    #fff 100%
  );
  position: relative;
  height: 100%;

  ${media.TABLET`
    width: 100%;
    height: 375px;
  `};
`;

const InnerSubWrapper = styled.div`
  width: 50%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
`;
const InnerSubWrapperRight = styled(InnerSubWrapper)`
  flex-direction: column-reverse;
`;

const SubWrapperDark = styled(SubWrapper)`
  background-color: rgba(0, 0, 0, 0.05);
  background-image: url(https://assets.saytechnologies.com/images/marketing-site/silver-microphone.png);
  background-repeat: no-repeat;
  background-size: 16%;
  background-position: center 110%;
  height: 100%;

  ${media.TABLET`
    height: 400px;
    background-size: 20%;
    background-position: center 100%;
  `};
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin: 15vh auto 0 auto;
  max-width: 430px;
  justify-content: flex-start;

  ${media.TABLET`
    align-items: center;
    margin: 5vh auto 0 auto;
    max-width: 90%;
  `};
`;

const Header = styled.div`
  display: flex;

  ${media.TABLET`
    align-items: center;
    flex-direction: column;
    width: 100%;
    margin-left: 0;
  `};
`;

const Heading = styled.h1`
  color: ${props => props.theme.colors.trueblack};
  font-size: 36px;
  font-weight: 700;
  letter-spacing: -0.3px;
  line-height: 1.1;

  ${media.TABLET`

    width: 100%;
    font-size: 32px;
  `};
`;

const HeadingContainer = styled.div`
  width: 150px;
  margin: 15vh auto 0 auto;
  ${media.TABLET`
    margin: 5vh auto 0 auto;
  `};
`;

const HeadingContainerRight = styled(HeadingContainer)`
  margin: 0 auto 15vh auto;

  ${media.TABLET`
    margin: 0 auto 5vh auto;
  `};
`;

const BrokersHeading = styled(Heading)`
  margin: 0 0 15px 0;
`;
const IssuersHeading = styled(BrokersHeading)`
  color: ${({ theme }) => theme.colors.white};
`;

const HeadingLink = styled(Link)`
  color: ${({ theme }) => theme.colors.blue};
  text-decoration: none;
  &:hover {
    color: ${({ theme }) => theme.colors.blue};
    text-decoration: none;
  }
`;

const SayPowers = styled.p`
  text-align: center;
  font-family: ${({ theme }) => theme.fonts.serif};
  margin-bottom: 10vh;
  order: 1;
  font-size: 22px;
  line-height: 1.35;

  ${media.TABLET`
    width: 90%;
    margin: 0 auto 10vh auto;
    text-align: left;
    font-size: 16px;
  `};
`;

interface IMatchParams {
  referrerCode?: string;
}

interface IIndexProps extends RouteComponentProps<IMatchParams> {
  navOpen: boolean;
  setNavOpen: (navOpen: boolean) => void;
}

interface IIndexState {
  referrerCode?: string;
}

class Index extends React.Component<IIndexProps, IIndexState> {
  public constructor(props: IIndexProps) {
    super(props);

    this.state = {
      referrerCode: this.props.match.params.referrerCode
    };
  }

  public render() {
    const { navOpen, setNavOpen } = this.props;
    return (
      <div
        onClick={() => {
          if (navOpen) {
            setNavOpen(false);
          }
        }}
      >
        <Helmet>
          <title>Say</title>
        </Helmet>

        {/* <Overlay /> */}

        <Wrapper>
          <Nav showSayLogo={true} sayLogoFill="#000" />
          <InnerWrapperTop>
            <SubWrapperDark>
              <Content>
                <Header>
                  <Heading>
                    Investors now have
                    <br />a microphone.
                  </Heading>
                </Header>

                <WaitlistSignUpForm
                  initialReferrerCode={this.state.referrerCode}
                />
              </Content>
              {/* <IndexFooter /> */}
              {/* <OverlayMobile /> */}
            </SubWrapperDark>
            <SubWrapper>
              <InnerSubWrapper>
                <HeadingContainer>
                  <BrokersHeading>Brokers</BrokersHeading>
                  <HeadingLink to="broker-contact">Learn More</HeadingLink>
                </HeadingContainer>
              </InnerSubWrapper>
              <InnerSubWrapperRight>
                <HeadingContainerRight>
                  <IssuersHeading>Issuers</IssuersHeading>
                  <HeadingLink to="issuer-contact">Learn More</HeadingLink>
                </HeadingContainerRight>
              </InnerSubWrapperRight>
            </SubWrapper>
          </InnerWrapperTop>

          <InnerWrapperBottom>
            <SayPowers>
              Say powers connections between shareholders and their investments
              by partnering
              <br />
              with the world’s most innovative companies and financial
              institutions.
            </SayPowers>
            <IndexFooter />
          </InnerWrapperBottom>
        </Wrapper>
        <Footer hideFormOnMobile={true} />
      </div>
    );
  }
}

export default withRouter((props: RouteComponentProps<IMatchParams>) => (
  <Subscribe to={[AppContainer]}>
    {(app: AppContainer) => (
      <Index
        {...props}
        navOpen={app.state.navOpen}
        setNavOpen={app.setNavOpen}
      />
    )}
  </Subscribe>
));



// WEBPACK FOOTER //
// ./src/pages/Index/Index.tsx